import * as createEditTransferActions from './createEditTransfer/actions';
import * as transferOrderListActions from './TransferOrderList/actions';

export const actions = {
  ...transferOrderListActions,
  ...createEditTransferActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/actions.js